import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getLoginAnnouncement } from '../../services'
import { LoginAnnouncementQueryKeys } from '@/modules/client-setting/keys'
import { GetLoginAnnouncementResponse } from '@/modules/client-setting/type'

export default function useQueryGetLoginAnnouncement(
	props?: UseBaseQueryOptions<GetLoginAnnouncementResponse>,
) {
	return useQuery({
		queryKey: [LoginAnnouncementQueryKeys.GetLoginAnnouncement],
		queryFn: () => getLoginAnnouncement(),
		...props,
	})
}
